import axios from 'axios';

const publicIp = process.env.REACT_APP_BASE_URL

const service = axios.create({
    baseURL:publicIp,
    timeout:30000
})


service.interceptors.request.use(
    config => {
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
   
     const res = response.data


     if (res.code !== 200) {
        console.log(res.message || 'Error')

        return Promise.reject(new Error(res.message || 'Error'))
      } 
      return  Promise.resolve(res.data)
    },
    error => {
        console.log( error.message)
        return Promise.reject(error)
    }
)

export default service
